import React, { useContext, useState } from "react";
import "../styles/StartPage.scss";
import { GameContext } from "../App";

const StartPage = () => {
  const { setCurrentStep } = useContext(GameContext);
  const PUBLIC_URL = process.env.PUBLIC_URL || "";

  return (
    <div className="start-page-container">
      <img
        className="start-title"
        src={`${PUBLIC_URL}/images/start_title.png`}
        alt="button"
      ></img>
      <span
        className="start-button-container"
        onClick={() => setCurrentStep(1)}
      >
        <img
          className="start-button"
          src={`${PUBLIC_URL}/images/start_button.png`}
          alt="button"
        ></img>
      </span>
      <span className="tnc">
        <sup>*</sup>只限新客戶 。<br/>
        <sup>*</sup>禮券不可疊加, 每位只可領獎一次<br/>
        <sup>*</sup>以每電話號碼單位計算，只可以挑戰三次，以最高分數為最終獲勝。<br/>
        <sup>*</sup>此免費體驗療程必須於發出日期日起計，三個月內使用，逾期無效，並不作補發。<br/>
        <sup>*</sup>ANGEL FACE保留最終決定權。

      </span>
    </div>
  );
};

export default StartPage;
